import React from 'react';
import './Input.css';

const Input = ({ label, name, value, onChange, maxLength, type = "text" }) => {
    const handleInput = (e) => {
        let newValue = e.target.value;
        if (type === 'tel') {
            newValue = newValue.replace(/\D/g, ''); // Allow only digits for mobile number
        }
        // Call the onChange function with the updated value
        onChange({ target: { name, value: newValue } });
    };

    return (
        <div className="input-container">
            <input 
                className="input-field" 
                placeholder={label}
                type={type} 
                name={name} 
                value={value} 
                onChange={handleInput} // Attach the event handler
                pattern={type === 'tel' ? "[6-9]{1}[0-9]{9}" : undefined} // Pattern for Indian mobile numbers
                title={type === 'tel' ? "Please enter a valid 10-digit Indian mobile number starting with 6-9" : undefined} // Title for tooltip message
                required
                maxLength={maxLength}
            />
        </div>
    );
};

export default Input;
